import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs/';

@Injectable()
export class LoginModalService {
  private modalStatus = new BehaviorSubject<boolean>(true);
  public obvStep: Observable<boolean> = this.modalStatus.asObservable(); // convert to Observable for subscribing

  constructor() {
   }

  setPageLoaderStatus(value: boolean) {
    this.modalStatus.next(value);
  }

  getPageLoaderStatus(): Observable<boolean> {
    return this.obvStep;
  }
}
